
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/intelligence/reports/[slug]",
      function () {
        return require("private-next-pages/intelligence/reports/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/intelligence/reports/[slug]"])
      });
    }
  